// extracted by mini-css-extract-plugin
export default {"list":"items-grid_list__eOFgm","grid-5":"items-grid_grid-5__tKlhg","grid-4":"items-grid_grid-4__frMDW","grid-3":"items-grid_grid-3__MJ1br"};